// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__djvxq","svgDesktop":"BackButton_svgDesktop__4LAO5","svgMobile":"BackButton_svgMobile__BUBYm","hoverLine":"BackButton_hoverLine___HJeu"};